import { render, staticRenderFns } from "./listaArticulos.vue?vue&type=template&id=697abe04"
import script from "./listaArticulos.vue?vue&type=script&lang=js"
export * from "./listaArticulos.vue?vue&type=script&lang=js"
import style0 from "./listaArticulos.vue?vue&type=style&index=0&id=697abe04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports